import {
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  Typography,
} from '@material-ui/core';
import React from 'react';
import './index.scss';

interface ModalProps {
  title: string;
  content: React.ReactNode;
  open: boolean;
  close: () => void;
}

export const ModalCadastroCooperativa = ({
  title,
  content,
  close,
  open,
}: ModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby='form-dialog-title'
      className='form-dialog-cadastro-escolas'
      TransitionComponent={Fade}
      transitionDuration={{
        enter: 350,
      }}
    >
      <DialogTitle
        className='form-dialog-cadastro-title-modal'
        id='form-dialog-cadastro-title'
      >
        <Typography className='titleModal'>{title}</Typography>
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
};
